import { __awaiter } from "tslib";
import { useState } from 'react';
import axios from 'axios';
import { merge } from '@fluentui/react';
import { useQuery, } from '@tanstack/react-query';
import { formatOdataQuery } from './oDataQueryString/oDataQuery';
import { SINGLETON_DATA_STALE_TIME_MSEC } from '../../constants';
import { useAnalytics } from '@msrceng/analytics';
import { useOApiReady } from './util';
const defaultOptions = {
    enabled: true,
    isAuthRequired: true,
    isVerificationRequired: true,
    useQueryOptions: { keepPreviousData: true },
};
/** Premade Odata API for getting the first entry from the list */
export const useODataReadFirstApi = (
/** The url path (relative) of this entity on top of the apiRoot */
endpointName, 
/** Query filters & params for the paged GET query included in this definiton */
query = {}, 
/** Additional options */
options, queryKeyOverride) => {
    const { appInsights } = useAnalytics();
    const { enabled: isEnabledInOptions, uniqueIdentifier, useQueryOptions, isAuthRequired, isVerificationRequired, } = merge({}, defaultOptions, options);
    const [rowCount, setRowCount] = useState();
    const oDataQuery = merge({
        top: 1,
    }, query);
    /** Did our gates for verification/auth/etc pass? */
    const isReady = useOApiReady({ isAuthRequired, isVerificationRequired });
    /** Did *all* pre-request checks pass? */
    const enabled = isEnabledInOptions && isReady;
    const api = useQuery(Object.assign(Object.assign({ queryFn: () => getEntity({
            oDataQuery,
            endpointName,
            uniqueIdentifier,
            setRowCount,
        }), onError: error => appInsights === null || appInsights === void 0 ? void 0 : appInsights.trackException({
            exception: error,
        }), retry: false, cacheTime: SINGLETON_DATA_STALE_TIME_MSEC, staleTime: SINGLETON_DATA_STALE_TIME_MSEC }, useQueryOptions), { 
        // This allows the query key to be overridden
        // which is important if you want a heirarchy that
        // doesn't start with the endpointName
        queryKey: queryKeyOverride || [
            endpointName,
            ...(useQueryOptions.queryKey || []),
            query,
        ], enabled }));
    return Object.assign(Object.assign({}, api), { rowCount });
};
const getEntity = ({ oDataQuery, endpointName, uniqueIdentifier, setRowCount, }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!axios.defaults.baseURL) {
        console.error('NOT YET READY');
        throw new Error('not ready');
    }
    const oDataString = formatOdataQuery(oDataQuery, uniqueIdentifier, false);
    return axios
        .get(`${endpointName}${oDataString && oDataString}`)
        .then(res => {
        var _a, _b;
        if (setRowCount) {
            setRowCount(res.data['@odata.count']);
        }
        return (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b[0];
    });
});
